export default __webpack_public_path__ + "static/media/Circe-Regular.9b873950.otf";